export default "Example\n";